export * from './bot-config-core.module';
export { RouterOutletComponent as BotConfigCoreRouterOutletComponent } from './router-outlet/router-outlet.component';
